import React,{useEffect,useState} from "react";
import { Col, Divider, Row } from 'antd';
import "./HomeResponsive.scss";
import HeaderDesktop from "../DesktopComponents/HeaderDesktop/HeaderDesktop";
import SliderDesktop from "../DesktopComponents/SliderDesktop/SliderDesktop";
import SingleBarDesktop from "../DesktopComponents/SingleBarDesktop/SingleBarDesktop";
import SingleBannerDesktop from "../DesktopComponents/SingleBannerDesktop/SingleBannerDesktop";
import {MyRecentMerchant} from "../Home/Sections";
import {Slider} from "../../Components";
import DualBarDesktop from "../DesktopComponents/DualBarDesktop/DualBarDesktop";
import ButtonListDesktop from "../DesktopComponents/ButtonListDesktop/ButtonListDesktop";
import TriadBigRightDesktop from "../DesktopComponents/TriadBigRightDesktop/TriadBigRightDesktop";
import ActualDesktop from "../DesktopComponents/ActualDesktop/ActualDesktop";
import {MultipleListDesktop} from "../DesktopComponents/MultipleListDesktop/MultipleListDesktop";
import {ProductRegalDesktop} from "../DesktopComponents/ProductRegalDesktop/ProductRegalDesktop";
import {ProductRegalNewDesktop} from "../DesktopComponents/ProductRegalDesktop/ProductRegalNewDesktop";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";
import BlogRegalDesktopSec from "../DesktopComponents/BlogRegalSec/BlogRegalSec";
import BlogRegalSec from "../Home/Sections/BlogRegalSec";
import {TagRegal} from "../../Components/TagRegal/TagRegal";
import {TagRegalNewDesktop} from "../DesktopComponents/TagRegalDesktop/TagRegalNewDesktop";
import {OffRegal} from "../../OffRegal/OffRegal";
import {OffRegalDesktop} from "../DesktopComponents/OffRegalDesktop/OffRegalDesktop";
import DrShopHeader from "../../Components/DrShopHeader/DrShopHeader";
import PrescriptionSec from "../Home/Sections/PrescriptionSec";
import TriadBigRightSec from "../Home/Sections/TriadBigRightSec";
import TriadBigLeftSec from "../Home/Sections/TriadBigLeftSec";
import TriadBigLeftDesktop from "../DesktopComponents/TriadBigLeftDesktop/TriadBigLeftDesktop";
import {VideoDesktop} from "../DesktopComponents/VideoDesktop/VideoDesktop";
import {TextDesktop} from "../DesktopComponents/TextDesktop/TextDesktop";
import {TSlider} from "../../Components/TSlider/TSlider";
import VideoSec from "../Home/Sections/VideoSec";
import {TSliderDesktop} from "../../Components/TSliderDesktop/TSliderDesktop";
import {BrandRegalDesktop} from "../BrandRegalDesktop/BrandRegalDesktop";
import ServiceSecDesktop from "../DesktopComponents/ServiceSecDesktop/ServiceSecDesktop";

const style = {
    background: '#0092ff',
    // padding: '8px 0',
};
function HomeResponsive ({
                             homi,
                             LinkDispatcher,
                             right_bottom,
                             right_top,
                             right,
                             left,
                             left_bottom,
                             left_top,
                         }){

    const [data,set_data] = useState([])
    const [mall,set_mall] = useState(null)

    useEffect(()=>{
        set_data(data)
        getMall()
    },[homi])


    const getMall = () =>{
        try{
            const localMall = localStorage.getItem('mall')
            if(localMall){
                set_mall(JSON.parse(localMall))
            }
        }catch(e){
            console.log(e)
        }
    }

    return(
        <div>
            <div className="home-fixed-container">
                {/*<HeaderDesktop/>*/}
                <DrShopHeader home={true}/>
                <div className="res-home-divider"></div>
                {homi.map(item => {
                    switch (item.section_type) {
                        case 'home_header':
                            return (
                                <HeaderDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                            )
                            break;
                        case 'slider':
                            return (
                                <SliderDesktop uid={item.uid} item={item} dispatch={LinkDispatcher} data={item.items}/>
                                // <TSliderDesktop uid={item.uid} item={item} dispatch={LinkDispatcher} data={item.items}/>
                            )
                            break;
                        case 'triad_big_left_slider':
                            return (
                                <TSliderDesktop item={item}/>
                            )
                            break;
                    }})}
            </div>
            <div className="home-responsive-container">
                <div className="home-responsive-body">
                    {homi.map(item => {
                        switch (item.section_type) {
                            case 'single_bar':
                                return (
                                    <SingleBarDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'single_banner':
                                return (
                                    <SingleBannerDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'dual_bar':
                                return (
                                    <DualBarDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'video_content':
                                return (
                                    <VideoDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            // case 'video_content':
                            //     return (
                            //         <VideoSec item={item}/>
                            //     )
                            //     break;
                            case 'text_content':
                                return (
                                    <TextDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'button_list':
                                return (
                                    <ButtonListDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'triad_big_right':
                                return (
                                    <TriadBigRightDesktop
                                        item={item}
                                        right={right} right_bottom={right_bottom} right_top={right_top}
                                        LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'triad_big_left':
                                return (
                                    <TriadBigLeftDesktop
                                        item={item}
                                        left={left} left_bottom={left_bottom} left_top={left_top}
                                        LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'service_section':
                                return (
                                    <ServiceSecDesktop
                                        item={item}
                                        left={left} left_bottom={left_bottom} left_top={left_top}
                                        LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'triad_big_right_slider':
                                return (
                                    <ServiceSecDesktop
                                        item={item}
                                        left={left} left_bottom={left_bottom} left_top={left_top}
                                        LinkDispatcher={LinkDispatcher}/>
                                )
                                break;

                            case 'blog_regal':
                                return (
                                    <BlogRegalDesktopSec item={item}/>
                                )
                                break;
                            case 'product_brand_regal':
                                return (
                                    <BrandRegalDesktop item={item}/>
                                )
                                break;
                            case 'actual_size_banner':
                                return (
                                    <ActualDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'multiple_banner':
                                return (
                                    <MultipleListDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case "product_tag":
                                return (
                                    <TagRegalNewDesktop item={item}/>
                                )
                                break;
                            case "off_products":
                                return (
                                    <OffRegalDesktop item={item}/>
                                )
                                break;
                            case 'product_category':
                                return (
                                    <ProductRegalNewDesktop item={item} sort={true} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            // case 'triad_big_right':
                            //     return (
                            //         <TriadBigRightSec item={item} right={right} right_bottom={right_bottom} right_top={right_top} LinkDispatcher={LinkDispatcher}/>
                            //     )
                            //     break;
                            // case 'triad_big_left':
                            //     return (
                            //         <TriadBigLeftSec item={item} left={left} LinkDispatcher={LinkDispatcher} left_bottom={left_bottom} left_top={left_top} />
                            //     )
                            //     break;
                            // case 'prescription':
                            //     return (
                            //         <PrescriptionSec item={item} LinkDispatcher={LinkDispatcher}/>
                            //     )
                            //     break;
                            // case 'product_category':
                            //     return (
                            //         <BlogRegalDesktopSec item={item} LinkDispatcher={LinkDispatcher}/>
                            //     )
                            //     break;


                        }})}


                </div>



            </div>

            <FooterDesktop/>
        </div>
            )

}
export default  HomeResponsive


